import Illusion from 'illusionjs'
import Model from '../Model'
import HasOneOrMany from './HasOneOrMany'
import { Collection } from '../Collection'

export class HasOne extends HasOneOrMany {

    public match(currentModels: Model[], relativeModels: Model[], relativeName: string): boolean {

		return this.matchOneOrMany(currentModels, relativeModels, relativeName, 'one')
	}

	public get():Promise<Collection> {
		// we rewrite the get in builder so we it can only get the first one
		// because it suppose to be one-to-one relationship
		return this.getRelativeBuilder().first()
	}

	public async findOrNew<A = any>(attributes?: A): Promise<Model> {

		const currentModel = this.getCurrentModel()

		const relativeModel = this.getRelativeModel()

		const foreignKey = this.getForeignkey()

		const foreignKeyId = currentModel.getPrimaryKeyId()

		const collections = await this.getRelativeBuilder().first()

		return Object.assign(
			collections.hasItem ? collections.getItems<Model>() : relativeModel,
			{
				...attributes, 
				[foreignKey]: foreignKeyId
			}
		)
	}
}

export default Illusion<typeof HasOne>(HasOne)